import { Box, Typography, useTheme } from '@mui/material';

const BetaLabel = () => {
  const theme = useTheme();
  const { secondary } = theme.palette;

  return (
    <Box sx={{ border: `1px solid ${secondary.main}`, borderRadius: '4px', px: 1, backgroundColor: secondary.light }}>
      <Typography variant="h6">BETA</Typography>
    </Box>
  );
};

export default BetaLabel;
